import { render, staticRenderFns } from "./EasyOrdersTableHead.vue?vue&type=template&id=643c2a39&scoped=true"
import script from "./EasyOrdersTableHead.vue?vue&type=script&lang=js"
export * from "./EasyOrdersTableHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643c2a39",
  null
  
)

export default component.exports